import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'

export async function checkIfTakingCarCouldBeDeleted(licensePlate) {
  try {
    const url = new URL(`${REACT_APP_API}/catalogs/checkIfTakingCarCouldBeDeleted`, window.location.href)
    url.searchParams.set('license_plate', licensePlate)

    const res = await axios.get(url.href)

    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

